var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelegram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6359 6.11477C17.6359 6.11477 19.116 5.55205 18.9927 6.91865C18.9516 7.48137 18.5816 9.45087 18.2938 11.5812L17.307 17.8916C17.307 17.8916 17.2248 18.8161 16.4847 18.9769C15.7447 19.1376 14.6346 18.4141 14.429 18.2533C14.2645 18.1328 11.3455 16.324 10.3176 15.4398C10.0298 15.1986 9.70084 14.7163 10.3587 14.1536L14.6757 10.1342C15.1691 9.65185 15.6624 8.52642 13.6067 9.89301L7.85071 13.7114C7.85071 13.7114 7.19288 14.1134 5.95947 13.7516L3.28702 12.9478C3.28702 12.9478 2.30027 12.3449 3.98596 11.7419C8.09741 9.85279 13.1545 7.92348 17.6359 6.11477Z",
    fill: "rgba(255, 255, 255, 0.5)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.5259fea9.svg";
export { ForwardRef as ReactComponent };